import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpErrorComponent } from '../../components/http-error/http-error.component';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-no-access',
    templateUrl: './no-access.component.html',
    styleUrl: './no-access.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HttpErrorComponent,
        MatIconModule
    ]
})
export class NoAccessComponent implements OnInit, OnDestroy {
  private intervalId?: ReturnType<typeof setInterval>;

  constructor(private router: Router) {}

  ngOnInit(): void {
    // // Try to redirect every 60 seconds
    // this.intervalId = setInterval(() => {
    //   this.tryRedirect();
    // }, 60000);
  }

  private tryRedirect(): void {
      this.router.navigate(['/']);
  }

  ngOnDestroy(): void {
    // Clear interval when component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}